import React, { useState } from "react";
import "./ManagementLeadFooterSection.css";

const programmes = [
  "Ph.D. in Management",
  "Master of Business Administration (MBA)",
  "Executive Master of Business Administration (EMBA)",
  "Bachelor of Business Administration (BBA)",
  "Post Graduate Diploma in Business Administration (PGDBA)",
  "Post Graduate Diploma in Business Management (PGDBM)",
  "Postgraduate Diploma in Management (PGDM)",
  "Diploma in Business Administration (DBA)",
];

const footerGroups = [
  {
    title: "Explore the school",
    links: [
      ["About the School", "#management-overview"],
      ["Programmes", "#management-programmes"],
      ["Faculty", "#management-faculty"],
      ["Learning Experience", "#learning-experience"],
      ["Placements", "#career-services"],
    ],
  },
  {
    title: "Admissions",
    links: [
      ["Admission Process", "#admission-process"],
      ["Eligibility", "#eligibility"],
      ["Scholarships", "/scholarships"],
      ["Download Prospectus", "/prospectus"],
      ["Frequently Asked Questions", "#management-faq"],
    ],
  },
  {
    title: "Student resources",
    links: [
      ["Student Services", "/student-services"],
      ["Academic Calendar", "/academic-calendar"],
      ["e-Library", "/e-library"],
      ["Placement Cell", "/placements"],
      ["Contact Us", "/contact-us"],
    ],
  },
];

export default function ManagementLeadFooterSection({ onSubmit }) {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);

    const form = event.currentTarget;
    const formData = Object.fromEntries(new FormData(form).entries());

    try {
      if (onSubmit) await onSubmit(formData);
      setSubmitted(true);
      form.reset();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="management-contact" id="management-contact">
      <section className="management-contact__lead" aria-labelledby="enquiry-title">
        <div className="management-contact__backdrop" aria-hidden="true">
          CONNECT
        </div>

        <div className="management-contact__inner">
          <div className="management-contact__intro">
            <span className="management-contact__eyebrow">
              <i aria-hidden="true" />
              Admissions 2026
            </span>
            <h2 id="enquiry-title">
              Your management journey
              <em> begins with a conversation.</em>
            </h2>
            <p className="management-contact__summary">
              Speak with our admissions team about programmes, eligibility,
              scholarships and the learning experience at the School of Management.
            </p>

            <div className="management-contact__channels">
              <a href="tel:+919373199999">
                <span className="management-contact__channel-icon" aria-hidden="true">01</span>
                <span>
                  <small>Call admissions</small>
                  <strong>+91 93731 99999</strong>
                </span>
                <b aria-hidden="true">↗</b>
              </a>
              <a href="mailto:admissions@isbmuniversity.edu.in">
                <span className="management-contact__channel-icon" aria-hidden="true">02</span>
                <span>
                  <small>Write to us</small>
                  <strong>admissions@isbmuniversity.edu.in</strong>
                </span>
                <b aria-hidden="true">↗</b>
              </a>
              <a href="/contact-us">
                <span className="management-contact__channel-icon" aria-hidden="true">03</span>
                <span>
                  <small>Experience the campus</small>
                  <strong>Plan a campus visit</strong>
                </span>
                <b aria-hidden="true">↗</b>
              </a>
            </div>

            <p className="management-contact__hours">
              <span aria-hidden="true" />
              Admission desk: Monday–Saturday, 9:30 AM–5:30 PM
            </p>
          </div>

          <div className="management-enquiry">
            <div className="management-enquiry__heading">
              <span>Request information</span>
              <strong>01—08</strong>
            </div>

            {submitted ? (
              <div className="management-enquiry__success" role="status" aria-live="polite">
                <span aria-hidden="true">✓</span>
                <h3>Thank you for reaching out.</h3>
                <p>
                  Your enquiry has been recorded. Our admissions team will connect
                  with you shortly.
                </p>
                <button type="button" onClick={() => setSubmitted(false)}>
                  Submit another enquiry
                </button>
              </div>
            ) : (
              <form className="management-enquiry__form" onSubmit={handleSubmit}>
                <div className="management-enquiry__field">
                  <label htmlFor="enquiry-name">Full name</label>
                  <input id="enquiry-name" name="name" type="text" placeholder="Your full name" required />
                </div>

                <div className="management-enquiry__field">
                  <label htmlFor="enquiry-email">Email address</label>
                  <input id="enquiry-email" name="email" type="email" placeholder="you@example.com" required />
                </div>

                <div className="management-enquiry__field">
                  <label htmlFor="enquiry-phone">Mobile number</label>
                  <div className="management-enquiry__phone">
                    <span>+91</span>
                    <input
                      id="enquiry-phone"
                      name="phone"
                      type="tel"
                      inputMode="numeric"
                      pattern="[0-9]{10}"
                      maxLength="10"
                      placeholder="10-digit number"
                      required
                    />
                  </div>
                </div>

                <div className="management-enquiry__field">
                  <label htmlFor="enquiry-city">City / State</label>
                  <input id="enquiry-city" name="city" type="text" placeholder="Where are you from?" required />
                </div>

                <div className="management-enquiry__field management-enquiry__field--full">
                  <label htmlFor="enquiry-programme">Programme of interest</label>
                  <select id="enquiry-programme" name="programme" defaultValue="" required>
                    <option value="" disabled>Select a management programme</option>
                    {programmes.map((programme) => (
                      <option value={programme} key={programme}>{programme}</option>
                    ))}
                  </select>
                </div>

                <label className="management-enquiry__consent">
                  <input type="checkbox" name="consent" required />
                  <span>
                    I agree to receive admission information by phone, email or
                    message and accept the university’s privacy policy.
                  </span>
                </label>

                <button className="management-enquiry__submit" type="submit" disabled={submitting}>
                  <span>{submitting ? "Sending enquiry…" : "Request a callback"}</span>
                  <i aria-hidden="true">↗</i>
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </footer>
  );
}
